module.exports = __webpack_public_path__ + "static/media/k12_logo_new_2x.ba9a737c.png";